// ** React Imports
import { createContext, useState } from 'react'
import PropTypes from 'prop-types';

// ** Create Context
export const UserContext = createContext({
    user: undefined,
    setUser: (/** @type {any} */ _) => { _ }
})

export const UserContextProvider = ({ children }) => {
    // ** State
    const [user, setUser] = useState();

    return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>
}

UserContextProvider.propTypes = {
    children: PropTypes.element
}

export const UserConsumer = UserContext.Consumer
